import { QuoteStatus } from '@graphql';
import { CUSTOMER_APPLICATION_BASE_URL, FINANCIAL_PRODUCT } from './constants';

// this can be shared
export const getTrackingId = () => {
  const queryParams = new URLSearchParams(window.location.search);
  return queryParams.get('trackingId') ?? '';
};

export function isJointApplicant() {
  const queryParams = new URLSearchParams(window.location.search);
  return queryParams.get('joint') === 'true';
}

export const redirectToApplicationForm = (trackingId: string) => {
  return window.location.replace(
    encodeURI(
      `${CUSTOMER_APPLICATION_BASE_URL[import.meta.env.VITE_ENVIRONMENT ?? 'staging']}?trackingId=${trackingId}${isJointApplicant() ? `&joint=true` : ''}`,
    ),
  );
};

export const getVendorInitials = (name: string) => {
  const initials = name
    .split(' ')
    .map(item => item[0])
    .join('');

  if (initials.length <= 2) {
    return initials;
  } else {
    return initials.substring(0, 2);
  }
};

export const isCbaProduct = (financialProductId?: string): boolean =>
  financialProductId === FINANCIAL_PRODUCT.CBA_RESIDENTIAL;

export const isCbaApplicationUrl = (applicationUrl: string): boolean => {
  try {
    const url = new URL(applicationUrl);
    return (
      url.protocol === 'https:' && (url.hostname === 'commbank.com.au' || url.hostname.endsWith('.commbank.com.au'))
    );
  } catch {
    return false;
  }
};

// Statuses where the buyer can still choose this quote. Anything past selection is a record of
// what happened, not an option to pick.
const SELECTABLE_QUOTE_STATUSES = [QuoteStatus.SENT, QuoteStatus.STARTED];

// CBA keeps post-selection and expired quotes on the package screen so they can be rendered in
// their buckets. DECLINED and CANCELLED stay excluded; those quotes should not be displayed.
const CBA_PACKAGE_QUOTE_STATUSES = [QuoteStatus.ACCEPTED, QuoteStatus.COMPLETED, QuoteStatus.EXPIRED];

export const isQuoteSelectable = (quoteStatus: QuoteStatus): boolean => SELECTABLE_QUOTE_STATUSES.includes(quoteStatus);

// The quote whose card owns the CBA application: ACCEPTED until the application is created, then
// COMPLETED once finance stamps every trackingId in the package on application creation.
export const ownsCbaApplication = (quoteStatus: QuoteStatus): boolean =>
  quoteStatus === QuoteStatus.ACCEPTED || quoteStatus === QuoteStatus.COMPLETED;

export const accessibleQuote = (quoteStatus: QuoteStatus, financialProductId?: string): boolean => {
  if (isCbaProduct(financialProductId)) {
    const CBA_ACCESSIBLE_QUOTE_STATUSES = [...SELECTABLE_QUOTE_STATUSES, ...CBA_PACKAGE_QUOTE_STATUSES];
    return CBA_ACCESSIBLE_QUOTE_STATUSES.includes(quoteStatus);
  }

  return SELECTABLE_QUOTE_STATUSES.includes(quoteStatus);
};

export const isQuoteVisible = (quoteStatus: QuoteStatus): boolean => {
  return SELECTABLE_QUOTE_STATUSES.includes(quoteStatus);
};
